module.exports = __webpack_public_path__ + "static/img/DSC_0064.c53510a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0064.jpg
// module id = 7nNs
// module chunks = 0